import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/privacy/page.tsx");
